import { TableCell, TableRow, Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { DailyWebHookType } from "src/types/graphql.ts";

/**
 * Types
 */
interface Props {
  webhook: DailyWebHookType;
}

const DailyWebhook: React.FC<Props> = ({ webhook }: Props) => {
  return (
    <TableRow>
      <TableCell align="left">{webhook?.url}</TableCell>

      <TableCell align="left">
        {" "}
        <Typography variant="body2" color="secondary">
          {webhook?.state}{" "}
        </Typography>
      </TableCell>

      <TableCell align="left">{webhook?.retryType}</TableCell>

      <TableCell align="left">
        {webhook?.eventTypes?.map((eventType, index: number) => (
          <span key={eventType}>
            {`${eventType}`}
            {index !== webhook?.eventTypes?.length - 1 ? <span>, </span> : null}
          </span>
        ))}
      </TableCell>

      <TableCell align="center" sx={{ minWidth: "120px" }}>
        {format(new Date(webhook?.createdAt), "yyyy-MM-dd")}
      </TableCell>
    </TableRow>
  );
};

export default DailyWebhook;
